export const locale = {
    lang: 'ds',
    data: {
        'TABS': {
            'Economy': 'Økonomi',
            'OtherDetails': 'Andre detaljer',
            'Files': 'Filer',
            'MtoM': 'M til M',
            'Note': 'Bemærk',
            'Offers': 'Tilbud'
        },
        'Headers': {
            'Co-workerlist': 'Medarbejderliste',
            'RequisionCoworkerlist': 'Rekvisition Medarbejderliste',
            'ChooseFile': 'Vælg fil',
            'ProjectWorkInfo': 'Projekt info',
        },
        'MESSAGES': {
            'Add': 'Oprettet',
            'Delete': 'Slettet med succes',
            'Add_Error': 'Ingen registrering fundet på Vagttider eller Vagtplan bordet, kontakt venligst til administrator.',
            'Some_Coworker_Add_Error': 'Nogle kolleger kan ikke tilføje arbejdstid.',
            'CanNotAddWorkHour': '{@Coworker} medarbejdere Kan ikke tilføje arbejdstid.',
            'Updated': 'Opdateret med succes',
            'Failed': 'Operation mislykket, prøv senere',
            'HolidayFoundInPlanning': 'Følgende dage: @date er helligdage. Du har 3 muligheder.',
            'CoworkerOnLeave': '@coworkerName har @statusName @date Vil du planlægge på denne dag. Du har 3 muligheder.',
            'LeftAssigment': 'Lift er allerede tildelt på denne @date',
            'NORECORD': 'Ingen registrering fundet',
            'ConfirmNoOfCoworker':'Du har valgt mere medarbejdere, end du har tilføjet i Antal arbejdsgange.<br/> Er du sikker på, at du vil planlægge?',
            'AlreadyProjPlanned':'Dette projekt er allerede planlagt på denne dato på denne medarbejder',
            'CannotPlanning': 'Du kan ikke planlægge projekt uden økonomiske detaljer',
            'ColorCodeBlank': 'Projektet har ikke farvekode.',
        },
        'Button': {
            'Plan': 'Planlæg / Gem',
            'Cancel': 'Gå tilbage',
            'Delete': 'Slette',
            'DeleteFutureWorkHour': 'Slet fremtidig arbejdstid',
            'GoToProject': 'Gå til sagen',
            'ViewCoworkerPlanning': 'Se medarbejderplanlægning',
            'Material':'Materialer',
            'GotoOffer':'Gå til tilbud'
        },
        'FIELDS': {
            'Coworker': 'Medarbejdere',
            'Project': 'Projekt',
            'StartDate': 'Start dato ',
            'EndDate': 'Slut dato ',
            'Shift': 'Tids rum',
            'Not-Found-Worker': 'Medarbejder ikke fundet',
            'Not-Found-Project': 'Projekt not found',
            'Requisition': 'Opgave',
            'EnterStarttime': 'Indtast starttidspunkt',
            'EndTime': 'Indtast slutstidspunkt',
            'Startime': 'Starttidspunkt',
            'Endtime': 'Slut tid',
            'BreakTime': 'Tilføj Break tid (30 min)',
            'WorkhoursType': 'Arbejdstid type',
            'nonStatus': 'Status',
            'nonText': 'Tekst',
            'WeekNumber': 'Uges nummer',
            'IndoorOutDoor': 'Ind, ud, Sprøjt, Reklamation',
            'UrgentOrNot': 'Haster/Haster Ikke',
            'Visit': 'Besøg',
            'DepartmentPhone': 'Telefon',
            'Size': 'Kvadratmeter',
            'IsHourlyWage': 'Er sag på timeløn',
            'Status': 'Status',
            'SRNO': 'Sr nr.',
            'NoOfWorkflows':'Antal arbejdsgange',
            'IsNotifyToCustomer': 'Er Underrette TilKunde',
            'PlaninginWeekend':'Planlægning i weekenden',
            'VisitDays':'Besøgsdage',
            'ProjectBasedPlanning': 'Projektbaseret planlægning',
            'ColorCode': 'Farvekode',
            'AutomaticallyCalculated':'Ikke beregne data'
        },
        'selectedOption': {
            'value1': 'Tilføj 07:00 til 14:30',
            'value2': 'Tilføj 07:00 til 15:00',
            'value3': 'Tilføj timer manuelt',
        },
        'Header': {
            'Add7to0230': 'Tilføj 07:00 til 14:30',
            'Add7to03': 'Tilføj 07:00 til 15:00',
        },
        'Lable': {
            'Timer': 'Timer',
            'HoursLeft': 'Timer tilbage',
            'PlannedHours': 'Planlagte timer',
            'RemainingPlannedHours': 'Resterende plan time',
            'Lift': 'Lift',
            'Stigemand': 'Stigemand',
            'RequisitionText': 'Opgave tekst',
            'No': 'Nej',
            'Yes': 'Ja',
            'Estimate': 'Overslagspris',
            'Price-included': 'Pris incl. Moms',
            'Price-excluded': 'Pris excl. Moms',
            'VAT': 'Moms',
            'MaterialTotalPrice': 'Materiale I alt',
            'MaterialTotalPriceIncludeVAT': 'Materiale I alt incl. Moms',
            'MaterialPersonalTotalPrice': 'Materiale Personlig Pris I alt',
            'hoursOnCase': 'Timer til sagen',
            'noOfDays': 'Hvor mange dage',
            'Hoursspent': 'Timer brugt',
            'Name': 'Navn',
            'Hours': 'Timer',
            'TotalHours': 'Samlede timer',
            'ScheduledDates': 'Planlagte datoer',
        },
        'selectedWorkHourStatus': {
            'value1': 'Ferie ',
            'value2': 'Syg',
            'value3': 'Feriefridag',
            'value4': 'Fridag m.løn',
            'value5': 'Fridag u.løn',
            'value6': 'Kursus/skole',
            'value7': 'Afspadsering',
            'value8': 'Andet',
            'value9': 'Tilbud'
        },
        'UrgentOrNot': {
            'value0': 'Vælg',
            'value1': 'Haster',
            'value2': 'Haster Ikke',
        },
        'selectedValueIndoorOutdoorStatus': {
            'value1': 'Indendørs ',
            'value2': 'Udendørs',
            'value3': 'Sprøjtemaling',
            'value4': 'Reklamation',
            'value5': 'Personale køb', //drawing of painter
            'value6': 'Butiks køb'     //Nordsjø logo
        },
        // 'selectedValueStatus': {
        //     'value0': 'Anbefalet',
        //     'value1': 'Process',
        //     'value2': 'Planlagt besøg',
        //     'value3': 'Klar til opstart',
        //     'value4': 'Tilbud sendt',
        //     'value5': 'Tilbud godkendt',
        //     'value6': 'Planlagt',
        //     'value7': 'Tilbud afvist',
        //     'value8': 'Startet',
        //     'value9': 'Udført',
        //     'value10': 'Faktureret',
        //     'value11': 'Afventer',
        //     'value12': 'Klar fakturering',
        // }
        'selectedWeekendOption': {
            'value1': 'Uden Weekend',
            'value2': 'Med Weekend'
        },
        'selectedShiftOption': {
            'value1': '07:00 til 14:30',
            'value2': '07:00 til 15:00',
            'value3': 'timer manuelt',
        },
        'selectedShifttimeOption': {
            'value1': 'Skiftetid',
            'value2': 'Besøgstid'
        },
    }
};
